import React, { useState, useRef } from "react";
import { KpiIcon } from "../../KpiIcons";

const FileUploadZone = ({
  onFile,
  uploading,
  uploadPct,
  uploadedMeta,
  onClear,
  disabled,
}) => {
  const [drag, setDrag] = useState(false);
  const fileRef = useRef(null);

  const handleDrop = (e) => {
    if (disabled) return;
    e.preventDefault();
    setDrag(false);
    const f = e.dataTransfer.files?.[0];
    if (f) onFile(f);
  };

  if (uploadedMeta) {
    const isDoc = !!uploadedMeta.fileMetadataId;
    return (
      <div
        style={{
          borderRadius: 9,
          overflow: "hidden",
          border: "1px solid var(--blue2)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "9px 13px",
            background: "var(--blue3)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <KpiIcon name="upload" size={14} color="var(--blue)" />
            <div>
              <div
                style={{ fontWeight: 700, fontSize: 12, color: "var(--ink)" }}
              >
                {isDoc ? "File attached as proof" : "Spreadsheet data extracted"}
              </div>
              {uploadedMeta.fileName && (
                <div
                  style={{
                    fontSize: 10.5,
                    color: "var(--ink3)",
                    marginTop: 1,
                  }}
                >
                  {uploadedMeta.fileName}
                  {uploadedMeta.fileSize
                    ? ` · ${Math.round(Number(uploadedMeta.fileSize) / 1024)} KB`
                    : ""}
                </div>
              )}
            </div>
          </div>
          {!disabled && (
            <button
              onClick={onClear}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: 11,
                color: "var(--ink4)",
                fontFamily: "var(--ff)",
                padding: "2px 8px",
                borderRadius: 5,
              }}
            >
              ← replace
            </button>
          )}
        </div>
        {isDoc && (
          <div
            style={{
              padding: "7px 13px",
              background: "var(--card)",
              fontSize: 11,
              color: "var(--ink3)",
            }}
          >
            Proof document saved — data fields below are still required.
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className={`ahp-drop${drag ? " active" : ""}${
        !disabled ? " clickable" : ""
      }`}
      style={{ opacity: disabled ? 0.5 : 1 }}
      onDragOver={(e) => {
        if (!disabled) {
          e.preventDefault();
          setDrag(true);
        }
      }}
      onDragLeave={() => setDrag(false)}
      onDrop={handleDrop}
      onClick={() => !uploading && !disabled && fileRef.current?.click()}
    >
      <input
        ref={fileRef}
        type="file"
        hidden
        disabled={disabled}
        accept=".csv,.xlsx,.xls,.pdf,.doc,.docx,.jpg,.jpeg,.png"
        onChange={(e) => e.target.files[0] && onFile(e.target.files[0])}
      />
      {uploading ? (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 8,
            }}
          >
            <span
              className="ahp-spin"
              style={{
                width: 18,
                height: 18,
                border: "2px solid var(--bdr)",
                borderTopColor: "var(--blue)",
              }}
            />
          </div>
          <div
            style={{
              fontSize: 12,
              fontWeight: 700,
              color: "var(--ink2)",
              marginBottom: 4,
            }}
          >
            Processing…
          </div>
          <div className="ahp-prog">
            <div
              className="ahp-prog-f"
              style={{ width: `${uploadPct}%` }}
            />
          </div>
          <div
            style={{
              fontSize: 10,
              color: "var(--ink4)",
              fontFamily: "var(--fm)",
            }}
          >
            {uploadPct}%
          </div>
        </div>
      ) : (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 8,
            }}
          >
            <KpiIcon name="upload" size={20} color="var(--ink4)" />
          </div>
          <div
            style={{
              fontSize: 12,
              fontWeight: 700,
              color: "var(--ink2)",
              marginBottom: 8,
            }}
          >
            Drop a file or click to browse
          </div>
          <div
            style={{
              display: "flex",
              gap: 6,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            {[
              { label: "XLSX / CSV", sub: "auto-fills form" },
              { label: "PDF / DOC", sub: "stored as proof" },
              { label: "JPG / PNG", sub: "stored as proof" },
            ].map(({ label, sub }) => (
              <div
                key={label}
                style={{
                  padding: "4px 10px",
                  borderRadius: 6,
                  background: "var(--card)",
                  border: "1px solid var(--bdr)",
                }}
              >
                <div
                  style={{
                    fontSize: 10.5,
                    fontWeight: 700,
                    color: "var(--ink2)",
                  }}
                >
                  {label}
                </div>
                <div style={{ fontSize: 9.5, color: "var(--ink4)" }}>
                  {sub}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FileUploadZone;
